// SPDX-License-Identifier: AGPL-3.0-or-later

import {JsVoiceEngine} from '@app/features/voice/engine/native_voice_engine/JsVoiceEngine';
import {NativeVoiceEngine} from '@app/features/voice/engine/native_voice_engine/NativeVoiceEngine';
import {
	isNativeVoiceEngineSelected,
	resetNativeVoiceEngineSelectionForTesting,
	suppressNativeVoiceEngineSelectionForFallback,
} from '@app/features/voice/engine/native_voice_engine/NativeVoiceEngineSelection';
import type {VoiceEngine} from '@app/features/voice/engine/native_voice_engine/VoiceEngine';

export {
	isNativeVoiceEngineSelected,
	isNativeVoiceEngineSelectionPending,
	shouldUseNativeVoiceEngine,
} from '@app/features/voice/engine/native_voice_engine/NativeVoiceEngineSelection';

let cachedEngine: VoiceEngine | null = null;

export function getVoiceEngine(): VoiceEngine {
	const wantNative = isNativeVoiceEngineSelected();
	if (cachedEngine && (cachedEngine.kind === 'native') === wantNative) {
		return cachedEngine;
	}
	if (wantNative) {
		const bridge = window.electron?.voiceEngine;
		if (bridge) {
			cachedEngine = new NativeVoiceEngine(bridge);
			return cachedEngine;
		}
	}
	cachedEngine = new JsVoiceEngine();
	return cachedEngine;
}

export function suppressNativeVoiceEngineForFallback(): void {
	suppressNativeVoiceEngineSelectionForFallback();
	if (cachedEngine?.kind === 'native') {
		cachedEngine = null;
	}
}

export function resetVoiceEngineForTesting(): void {
	cachedEngine = null;
	resetNativeVoiceEngineSelectionForTesting();
}
